import { Component, OnInit,Input,ChangeDetectorRef } from '@angular/core';
import { ModalController} from '@ionic/angular';

@Component({
  selector: 'filter',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss'],
})
export class FilterModalComponent implements OnInit {
  @Input() filter: any;
  @Input() appliedFilter: any;
  public category: any;
  public subCategory: any;
  public selectedFilter: any;
  constructor(
    private modalController: ModalController,
  ){}

  public currentHeaderData: any = {
    modalSlotEnd: true,
    title: 'modals.filter_modal.all_filters',
    marl20: true,
    mart4: true,
  };

  ngOnInit() {
    this.category = this.filter[0].displayName;
    this.subCategory = this.filter[0].facets.map((value: any) => value);
    this.appliedFilter = this.appliedFilter || {};
  }

  getCategory(category: any){
   this.category = category.displayName;
   this.subCategory = category.facets.map((value: any) => value);
  }

  getCheckedItem(event: any,item: any){
    if(Object.keys(this.appliedFilter).length === 0){
      this.appliedFilter = {[this.category]:[item.name]};
    }else{
      if(this.appliedFilter[this.category]){
        if(event.target.checked){
        this.appliedFilter = {...this.appliedFilter, [this.category]: [...this.appliedFilter[this.category],item.name]};
        }else{
        this.appliedFilter =
         ({...this.appliedFilter,[this.category]: this.appliedFilter[this.category].filter((filterItem: any) => filterItem !== item.name)});
        }
      }else{
       this.appliedFilter = {...this.appliedFilter, [this.category]:[item.name]};
      }
    }
  }

  isChecked(item: any){
    if(Object.keys(this.appliedFilter).length !== 0){
      if(this.appliedFilter[this.category]){
        return this.appliedFilter[this.category].includes(item.name);
      }
      else{
        return false;
      }
    }
    else{
      return false;
    }
  }

  resetFilter(){
    this.modalController.dismiss({type:'ResetFilter',selectedFilter:undefined,appliedFilter:{}});
  }

  applyFilter(){
    const removeEmptyArray = Object.entries(this.appliedFilter).filter((item: any) => item[1].length !== 0);

    this.selectedFilter =  removeEmptyArray.reduce((prev: any,item: any) =>
    ({...prev,[item[0]]:item[1].map((mapItem: any) => mapItem).join(',')}),{});

    this.appliedFilter = removeEmptyArray.reduce((prev: any,item: any) =>
     ({...prev,[item[0]]:item[1].map((mapItem: any) => mapItem)}),{});

    this.modalController.dismiss({type:'ApplyFilter',selectedFilter:this.selectedFilter,appliedFilter:this.appliedFilter});
  }

  closeModal() {
    this.modalController.dismiss({type:'CloseModal', appliedFilter:this.appliedFilter});
  }
}
